const {h, render, Component} = require('preact');

class SeeAllGrouponPlus extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let count = this.props.length
    if (count > 4) {
      let seeAllGrouponPlus =
        <div class="landing-step-actions" data-bhw="web2018_see_all_claims">
          <a href="/customer_support/web/claims" class="btn-invert" id="see-all-claims">
            {I18n.t('js.modules.web_2018.see_all_groupon_plus')}
          </a>
        </div>
      return seeAllGrouponPlus;
    }
    return null;
  }
}

module.exports = SeeAllGrouponPlus
